import { AccountInfo } from "@azure/msal-browser";
import { logoutRedirect } from "../../Api/Common/Auth";
import { IColumn, IconButton, mergeStyleSets, Text } from "@fluentui/react";

const columns: IColumn[] = [
  {
    key: "tenantName",
    name: "Tenant",
    onRender: (item: { tenantName: unknown }) => <Text>{item.tenantName}</Text>,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    key: "name",
    name: "Username",
    onRender: (item: { name: unknown }) => <Text>{item.name}</Text>,
    minWidth: 100,
  },
  {
    key: "signOut",
    name: "Sign out",
    onRender: (item: { account: AccountInfo }) => {
      return (
        <IconButton
          iconProps={{ iconName: "SignOut" }}
          onClick={() => {
            logoutRedirect(item.account);
          }}
          className={styles.signOutButtonStyles}
        />
      );
    },
    minWidth: 70,
  },
];

const styles = mergeStyleSets({
  signOutButtonStyles: {
    height: 20,
  },
});

export { columns };
